function apiBaseUrl() {

    return "https://proxy.mueblesramis.net"; // production environment
    // return "https://theos.mueblesramis.net:4433"; // production environment
    // return "http://localhost:3000"; // local dev environment
}

export default apiBaseUrl();
